import React from 'react';

import PropTypes from 'prop-types';

import { Presets, ShipDate } from '../../../configure-shipment/fields';

const HeaderActions = ({ fulfillmentPlanId }) => {
  return (
    <>
      <ShipDate fulfillmentPlanId={fulfillmentPlanId} />
      <Presets fulfillmentPlanId={fulfillmentPlanId} />
    </>
  );
};

HeaderActions.propTypes = {
  fulfillmentPlanId: PropTypes.string.isRequired,
};

export { HeaderActions };
